import React from 'react';

import AppProfileMenu from '../../designe/app-profile-menu/AppProfileMenu';
import { useStyles } from './Header.styles';
import theme from '../../../styles/theme';
import GlobalSearch from '../global-search/GlobalSearch';

interface HeaderProps {
  children: React.ReactNode;
}

const Header = (props: HeaderProps) => {
  const { classes } = useStyles(theme);

  return (
    <header className={classes.headerWrapper}>
      <div className={classes.headerContent}>
        <div className={classes.leftPart}>{props.children}</div>
        <div className={classes.searchWrapper}>
          <GlobalSearch />
        </div>
        <div className={classes.rightPart}>
          <AppProfileMenu />
        </div>
      </div>
    </header>
  );
};

export default Header;
